import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineSelectDatePicker, Typography, useDevice } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { TriageRow } from '../TriageRow/TriageRow';
import s from './TriageEffectiveDateRow.module.scss';
export const GetTriageEffectiveDateRowTID = (parentTestId)=>getTestIds(parentTestId);
export const EffectiveDateRowTestIds = GetTriageEffectiveDateRowTID().EffectiveDateRowTestIds;
export const TriageEffectiveDateRow = (param)=>{
    let { model, onModelChange } = param;
    const { t } = useLocaleKeys();
    const { isMobileDevice } = useDevice();
    const label = t.agreementImport.triageModal.effectiveDateLabel();
    const currentDate = model.effectiveDate();
    const picker = /*#__PURE__*/ _jsx(InlineSelectDatePicker, {
        bi: {
            name: 'triage_effective_date'
        },
        testId: EffectiveDateRowTestIds.DatePicker(),
        value: currentDate,
        onChange: (date)=>onModelChange(model.setEffectiveDate(date)),
        disableErrors: true
    });
    if (isMobileDevice) {
        return /*#__PURE__*/ _jsxs("div", {
            "data-testid": EffectiveDateRowTestIds.Root(),
            className: s.mobileCard,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "secondary",
                    children: label
                }),
                picker
            ]
        });
    }
    return /*#__PURE__*/ _jsx(TriageRow, {
        label: label,
        testId: EffectiveDateRowTestIds.Root(),
        children: picker
    });
};
